import SvgIcon from "@mui/material/SvgIcon";

export const PendingRequestsIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      fill="none"
      viewBox="0 0 20 21">
      <g fill="#fff" clipPath="url(#clip0_30074_60000)">
        <path d="M16.667 18.372H2.5a1.25 1.25 0 01-1.25-1.25V2.956a1.25 1.25 0 011.25-1.25h14.167a.417.417 0 01.416.416v15.834a.417.417 0 01-.416.416zM2.5 2.54a.417.417 0 00-.417.417v14.166a.417.417 0 00.417.417h13.75v-15H2.5zM18.751 2.54h-.833v2.5h.833v-2.5zM18.751 5.873h-.833v2.5h.833v-2.5z"></path>
        <path d="M18.332 20.039H2.082v-.833h15.833v-10h.834v10.416a.417.417 0 01-.417.417zM9.165 10.04a2.083 2.083 0 110-4.167 2.083 2.083 0 010 4.166zm0-3.334a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"></path>
        <path d="M11.667 13.373h-5a.417.417 0 01-.417-.417v-.833c0-.72.267-1.414.75-1.947l.28-.308.617.56-.28.308c-.344.38-.534.874-.534 1.387v.416h4.167v-.416c0-.513-.19-1.008-.534-1.387l-.28-.31.618-.559.28.309c.483.533.75 1.227.75 1.947v.833a.417.417 0 01-.417.417z"></path>
      </g>
      <defs>
        <clipPath id="clip0_30074_60000">
          <path
            fill="#fff"
            d="M0 0H20V20H0z"
            transform="translate(0 .873)"></path>
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
